import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output } from '@angular/core';
import { UserContactStatus } from 'node_js/models/enums/user-contact-status';
import { UserContact } from 'node_js/models/tables/user_contact';
import { UserNotification } from 'node_js/models/tables/user_notification';
import { MainSliderSection } from 'src/app/pages/dashboard/dashboard.page';
import { UserAuthService } from 'src/app/services/user-auth.service';
import { UserContactService } from 'src/app/services/user-contact.service';
import { TutorialService } from 'src/app/services/tutorial.service';

enum ContactsSection {
  SUPPORT,
  FILTERED
}

export enum ContactsMode {
  //Regular contacts page
  REGULAR = "regular",
  //Select a contact
  SELECT = "select"
}

export interface SelectedContact {
  userContact:UserContact,
  contactsMode:ContactsMode
}

@Component({
  selector: 'contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
})
export class ContactsComponent  implements OnInit {

  ContactsMode = ContactsMode;
  ContactsSection = ContactsSection;
  MainSliderSection = MainSliderSection
  UserContactStatus = UserContactStatus;

  selectedContactsSection = ContactsSection.SUPPORT;
  contactsMode:ContactsMode = ContactsMode.REGULAR;

  @Output() selectedContactEvent: EventEmitter<SelectedContact> = new EventEmitter();
  @Output() changeSlideEvent: EventEmitter<MainSliderSection> = new EventEmitter();


  constructor(protected userAuthService:UserAuthService, private userContactService:UserContactService, public tutorialService: TutorialService) { }

  ngOnInit() {
    
  }

  changeContactsSection(contactsSection:ContactsSection){
    console.log("new contact section",contactsSection)
    this.selectedContactsSection = contactsSection;
  }


  selectedContactFunc(userContact:UserContact){
    this.userContactService.selectedUserContact = userContact;
    this.changeSlideEvent.emit(MainSliderSection.CONTACTINFO);
  }

  onAddContactClick() {
    this.tutorialService.noteAddContactTriggered();
    this.changeSlideEvent.emit(MainSliderSection.CONTACTINFO);
  }

  startTutorial() {
    this.tutorialService.startAddContactTutorial(true);
  }

}